<template>
    <div>
        <img src="../assets/zongku.jpg" alt="">
        <div class='popContainer'>
            <div class="rollback" @click="rollback()">

            </div>
            <div class="times">
                {{currentTime}}
            </div>
        </div>
        <div class="goBack" @click="rollback()">

        </div>
    </div>
</template>

<script>
	export default {
		name: "cell",
		data(){

			return{
				timer: "",
				currentTime: '',
			}
		},
		methods: {
			rollback(){
				this.$router.push('/navigation')
			}
		},
		created() {
			var _this = this;
			var times
			_this.timer = setInterval(function() {
				let  shi= new Date().getHours()
				let  fen= new Date().getMinutes()
				shi= shi <= 9 ? "0"+ shi : shi
				fen= fen <= 9 ? "0"+ fen : fen
				times =
					new Date().getFullYear() +
					"-" +
					(new Date().getMonth() + 1) +
					"-" +
					new Date().getDate() +
					" " +
					shi +
					":" +
					fen
				_this.currentTime= times
			}, 1000);
			// console.log(_this.currentTime)
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		}
	}
</script>

<style scoped>
    .goBack{
        width: 20%;
        height: 250px;
        /*background: crimson;*/
        position: absolute;
        top: 76%;
        left: 80%;
        right: 0;
        bottom: 0;
        overflow: hidden;
    }
    .popContainer{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0);
        width: 100%;
        height: 100px;
        color: cornsilk;
        z-index: 100;
    }
    .popContainer .rollback{
        width: 150px;
        height: 100px;
        /*background-color: red;*/
        position: absolute;
        top: 10px;
        left: 20px;
        right: 0;
        bottom: 0;
    }
    .popContainer .times{
        height: 20px;
        position: absolute;
        top: 80%;
        left: 80%;
        right: 0;
        bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/cell.vue